import cx from 'classnames';
import {useContext} from 'react';

import {UserSessionContext} from 'context';

import {SidebarView} from '../../types';

type SidebarContentProps = {
    header: React.ReactNode;
    view: SidebarView;
    children: React.ReactNode;
    contentPadding?: boolean;
}

export const SidebarContent: React.FC<SidebarContentProps> = ({header, view, contentPadding = true, children}: SidebarContentProps) => {
    const {sidebarView} = useContext(UserSessionContext);
    return (
        <div className={cx('tw-flex tw-flex-col tw-h-full', {'tw-hidden': sidebarView !== view})}>
            <div className='tw-flex tw-p-3 tw-mr-8'>
                {header}
            </div>
            <div className={cx('tw-flex-1 tw-overflow-y-auto', {'tw-px-3 tw-pb-3': contentPadding})}>
                {children}
            </div>
        </div>
    );
};